__turbopack_context__.v({
  "component": "index-module__W_Wxsq__component",
  "componentMobileReverse": "index-module__W_Wxsq__componentMobileReverse",
  "component__background": "index-module__W_Wxsq__component__background",
  "component__backgroundMobile": "index-module__W_Wxsq__component__backgroundMobile",
  "component__backgroundWrap": "index-module__W_Wxsq__component__backgroundWrap",
  "component__backgroundWrapContain": "index-module__W_Wxsq__component__backgroundWrapContain",
  "component__backgroundWrapReverse": "index-module__W_Wxsq__component__backgroundWrapReverse",
  "component__background_img": "index-module__W_Wxsq__component__background_img",
  "component__buttonStyle": "index-module__W_Wxsq__component__buttonStyle",
  "component__content": "index-module__W_Wxsq__component__content",
  "component__contentReverse": "index-module__W_Wxsq__component__contentReverse",
  "component__copy": "index-module__W_Wxsq__component__copy",
  "component__copyContainer": "index-module__W_Wxsq__component__copyContainer",
  "component__icon": "index-module__W_Wxsq__component__icon",
  "component__icon__dark": "index-module__W_Wxsq__component__icon__dark",
  "component__icon__red": "index-module__W_Wxsq__component__icon__red",
  "component__itemHeading": "index-module__W_Wxsq__component__itemHeading",
  "component__legal": "index-module__W_Wxsq__component__legal",
  "component__list": "index-module__W_Wxsq__component__list",
  "component__subtitle": "index-module__W_Wxsq__component__subtitle",
  "component__title": "index-module__W_Wxsq__component__title",
  "hide-for-large": "index-module__W_Wxsq__hide-for-large",
  "hide-for-large-only": "index-module__W_Wxsq__hide-for-large-only",
  "hide-for-medium": "index-module__W_Wxsq__hide-for-medium",
  "hide-for-medium-only": "index-module__W_Wxsq__hide-for-medium-only",
  "hide-for-small-only": "index-module__W_Wxsq__hide-for-small-only",
  "show-for-large": "index-module__W_Wxsq__show-for-large",
  "show-for-large-only": "index-module__W_Wxsq__show-for-large-only",
  "show-for-medium": "index-module__W_Wxsq__show-for-medium",
  "show-for-medium-only": "index-module__W_Wxsq__show-for-medium-only",
  "show-for-small-only": "index-module__W_Wxsq__show-for-small-only",
  "u-color-black": "index-module__W_Wxsq__u-color-black",
  "u-color-blue": "index-module__W_Wxsq__u-color-blue",
  "u-color-midnight": "index-module__W_Wxsq__u-color-midnight",
  "u-color-primary-dark": "index-module__W_Wxsq__u-color-primary-dark",
  "u-color-red": "index-module__W_Wxsq__u-color-red",
  "u-color-white": "index-module__W_Wxsq__u-color-white",
  "u-theme-black": "index-module__W_Wxsq__u-theme-black",
  "u-theme-blue": "index-module__W_Wxsq__u-theme-blue",
  "u-theme-dark": "index-module__W_Wxsq__u-theme-dark",
  "u-theme-light": "index-module__W_Wxsq__u-theme-light",
  "u-theme-red": "index-module__W_Wxsq__u-theme-red",
  "u-theme-white": "index-module__W_Wxsq__u-theme-white",
});
